import { createAction } from 'redux-actions';

export const GetListSeminarRequested = createAction('GET_LIST_SEMINAR_VIEWER_REQUESTED');
export const GetListSeminarReceived = createAction('GET_LIST_SEMINAR_VIEWER_RECEIVED');
export const GetListSeminarReceivedFailure = createAction('GET_LIST_SEMINAR_VIEWER_RECEIVED_FAILURE');
export const ClearListSeminar = createAction('CLEAR_LIST_SEMINAR_VIEWER');

export const GetDetailSeminarRequested = createAction('GET_DETAIL_SEMINAR_VIEWER_REQUESTED');
export const GetDetailSeminarReceived = createAction('GET_DETAIL_SEMINAR_VIEWER_RECEIVED');
export const GetDetailSeminarReceivedFailure = createAction('GET_DETAIL_SEMINAR_VIEWER_RECEIVED_FAILURE');
export const ClearDetailSeminar = createAction('CLEAR_GET_DETAIL_VIEWER_SEMINAR');

export const GetListSeminarNonAuthRequested = createAction('GET_LIST_SEMINAR_VIEWER_NON_AUTH_REQUESTED');
export const GetListSeminarNonAuthReceived = createAction('GET_LIST_SEMINAR_VIEWER_NON_AUTH_RECEIVED');
export const GetListSeminarNonAuthReceivedFailure = createAction('GET_LIST_SEMINAR_VIEWER_NON_AUTH_RECEIVED_FAILURE');
export const ClearListSeminarNonAuth = createAction('CLEAR_LIST_SEMINAR_VIEWER_NON_AUTH');

export const GetDetailSeminarNonAuthRequested = createAction('GET_DETAIL_SEMINAR_VIEWER_NON_AUTH_REQUESTED');
export const GetDetailSeminarNonAuthReceived = createAction('GET_DETAIL_SEMINAR_VIEWER_NON_AUTH_RECEIVED');
export const GetDetailSeminarNonAuthReceivedFailure = createAction('GET_DETAIL_SEMINAR_VIEWER_NON_AUTH_RECEIVED_FAILURE');
export const ClearDetailSeminarNonAuth = createAction('CLEAR_GET_DETAIL_VIEWER_SEMINAR_NON_AUTH');

export const RegisterSeminarRequested = createAction('REGISTER_SEMINAR_REQUESTED');
export const RegisterSeminarReceived = createAction('REGISTER_SEMINAR_RECEIVED');
export const RegisterSeminarReceivedFailure = createAction('REGISTER_SEMINAR_RECEIVED_FAILURE');
export const ClearRegisterSeminar = createAction('CLEAR_REGISTER_SEMINAR');

export const GetListSeminarPausedRequested = createAction('GET_LIST_SEMINAR_PAUSED_REQUESTED');
export const GetListSeminarPausedRequestedReceived = createAction('GET_LIST_SEMINAR_PAUSED_REQUESTED_RECEIVED');
export const GetListSeminarPausedRequestedReceivedFailure = createAction('GET_LIST_SEMINAR_PAUSED_REQUESTED_RECEIVED_FAILURE');
export const ClearListSeminarPaused = createAction('CLEAR_LIST_SEMINAR_PAUSED');
